@if (showUseMyLocation()) {
    <ion-item (click)="onUseMyLocationClick()" [disabled]="isLoading()" button="true" lines="all">
        @if (isLoading()) {
            <ion-spinner
                name="circular"
                color="primary"
                slot="start"
            ></ion-spinner>
            <ion-label>Getting your location...</ion-label>
        } @else {
            <lib-svg-icon
                [roundBorder]="true"
                borderColor="var(--ion-color-dark-40)"
                color="var(--ion-color-primary)"
                iconName="gps"
                slot="start"
            />
            <ion-label>{{ errorMessage() ?? 'Use my current location' }}</ion-label>
        }
    </ion-item>
}

@if (addressesFound().length > 0) {
    <ion-list>
        <ion-item-divider>Found addresses</ion-item-divider>
        <ion-item (click)="onAddressSelect(address)" *ngFor="let address of addressesFound()" button="true">
            <p class="text-dark">{{ address.formattedAddress }}</p>
        </ion-item>
    </ion-list>
}